import { CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";

const { ui } = constants.colors;
const darkGrey = ui.neutral[700];
const white = ui.white[700];
const { fontSize } = typographyStyles;

export const rootCss: CSSObject = {
  position: "relative",
  height: 0,
};

export const labelCss = (isHoveringElement: boolean): CSSObject => {
  return {
    ...fontSize.textXS,
    display: isHoveringElement ? "block" : "none",
    position: "absolute",
    background: darkGrey,
    borderRadius: "6px",
    color: white,
    left: "50%",
    padding: "8px 11px",
    transform: "translate(-50%, 0)",
    whiteSpace: "nowrap",
  };
};
